<div
	*ngIf="show"
	[@slideFromChip]
	class="pop"
	[class.pop--exhausted]="exhausted"
	role="status"
	data-testid="credit-low-balance-banner"
>
	<span class="pop__notch" aria-hidden="true"></span>

	<button
		close-overlay
		class="pop__close"
		ariaLabel="Dismiss the credit balance warning"
		data-testid="credit-low-balance-dismiss"
		(click)="dismiss()"
	></button>

	<div class="pop__head">
		<span class="pop__dot" aria-hidden="true"></span>
		<typography variant="p/sm_semibold" class="pop__title">
			{{ title }}
		</typography>
	</div>

	<typography variant="p/xs_regular" class="pop__body">
		{{ body }}
	</typography>

	<div class="pop__actions">
		<button
			*ngIf="canManageBilling"
			primary
			type="button"
			size="small"
			borderRadiusSize="small"
			data-testid="credit-low-balance-action"
			(click)="act()"
		>
			{{ actionLabel }}
		</button>
		<!-- A member may not buy, so where the purchase would be they are offered
		     to ask the master account — and, once asked, told when. -->
		<ng-container *ngIf="!canManageBilling && canAsk">
			<button
				*ngIf="!askedNote"
				primary
				type="button"
				size="small"
				borderRadiusSize="small"
				data-testid="credit-low-balance-ask"
				[style.visibility]="requestLoaded ? null : 'hidden'"
				[disabled]="askInFlight || !requestLoaded"
				(click)="ask()"
			>
				{{ askLabel }}
			</button>
			<typography
				*ngIf="askedNote"
				variant="p/xs_medium"
				class="pop__asked"
				data-testid="credit-low-balance-asked"
			>
				{{ askedNote }}
			</typography>
		</ng-container>
		<button type="button" class="pop__link" (click)="openStatement()">
			<typography variant="p/xs_semibold">View statement</typography>
		</button>
	</div>
</div>
